import { PaginationQueryParams } from '@forwardflow/types'
import { create } from 'zustand'

type State = PaginationQueryParams

type Action = {
   setQueryParams: (updatedParams: State) => void
}

export const useOrganizationCampaignsFilter = create<Action & State>()(
   (set) => ({
      page: 1,
      sorts: '',
      fields: '',
      filters: '',
      search: '',
      limit: 20,
      includes: '',
      setQueryParams: (updatedParams) =>
         set((state) => ({
            ...state,
            ...updatedParams,
         })),
   })
)
